import { render, staticRenderFns } from "./LoadingButton.vue?vue&type=template&id=a1cdcb1a&"
import script from "./LoadingButton.vue?vue&type=script&lang=js&"
export * from "./LoadingButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports